module.exports = __webpack_public_path__ + "img/57_5.900d523c.png";